import { Navigate, parsePath } from "react-router-dom";

import { FullScreenLoader } from "@/components/common";
import { ROUTES } from "@/constants/routes";
import { useMagicLogin } from "@/features/Auth/hooks/useMagicLogin";

const MagicLogin = () => {
  const { status, targetUrl } = useMagicLogin();

  switch (status) {
    case "pending":
      return <FullScreenLoader />;
    case "success":
      return <Navigate to={targetUrl} replace />;
    case "error":
      return (
        <Navigate to={ROUTES.LOGIN} replace state={{ from: parsePath(targetUrl) }} />
      );
    default:
      return <Navigate to={ROUTES.LOGIN} replace />;
  }
};

export default MagicLogin;
